import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import DetailToolBar from '../fw/DetailToolBar.react.js';
import DetailBox from '../fw/DetailBox.react.js';
import TableDetail from '../fw/TableDetail.react';
import {injectIntl, FormattedMessage, IntlShape} from 'react-intl';
import RefreshButton from './RefreshButton.react';

import types from '../../common/model-api/types';
import Grid from '../fw/Grid.react';
import urlMapping from '../app/URLMapping';
import * as Tool from '../fw/Tool';
import {STATUS_FINISHED, STATUS_FAILED} from '../../common/model-api/JobType';
import ChannelIcon from '../channel-defs/ChannelIcon.react';
import {renderProgress} from './JobView.react';
import * as Permission from '../../common/util/Permission';

import './progress.scss';
import * as BrowserPermission from '../BrowserPermission';
import { Job } from '../../common/types/types';

interface JobDetailProps {
 intl: IntlShape;
 job: Job;
 relay: object;
}

class JobDetail extends React.Component<JobDetailProps> {

    typeName = 'jobs';

    constructor(props) {
        super(props);
    }

    static propTypes = {
        intl: PropTypes.object.isRequired,
        job: PropTypes.object.isRequired,
        relay: PropTypes.object.isRequired,
    };

    render() {
        let job = this.props.job;

        let type = types[this.typeName];

        return (
            <div className="job-page">

                <DetailBox data={job} metadata={type} urlMapping={urlMapping}>
                    <DetailToolBar data={job} metadata={type} urlMapping={urlMapping}>
                        <RefreshButton autoRefresh={job.status !== STATUS_FINISHED && job.status !== STATUS_FAILED} fastRefresh relay={this.props.relay} />
                    </DetailToolBar>

                    <h2>{job.channel && job.channel.channelDef ? <div style={{display: "inline-block", marginRight: ".5em"}}><ChannelIcon channelDef={job.channel.channelDef} size={64}/></div> : null} {job.name ? job.name : (job.channel && job.channel.channelDef ? job.channel.channelDef.name : null)}</h2>

                    <TableDetail columns={{
                        'type': {},
                        'name': {},
                        'status': {
                            // eslint-disable-next-line max-params
                            render: (column, item, url, columnMapping) => {
                                return renderProgress(type, job, this.props.intl.formatMessage);
                            }
                        },
                        'createdAt': {},
                        'updatedAt': {},
                        'stop': {},
                        'message': {}
                    }} data={job} metadata={type} />

                    {BrowserPermission.hasPermission(Permission.PERM_DEVELOPER) && BrowserPermission.developerModeEnabled() ? <TableDetail columns={{
                        'productVersion': {},
                        'productStage': {},
                    }} data={job} metadata={type} /> : null}

                </DetailBox>

                <div style={{paddingLeft: '15px', paddingRight: '15px'}}>
                    {job.errorStack && BrowserPermission.hasPermission(Permission.PERM_DEVELOPER) && BrowserPermission.developerModeEnabled() ? <pre>{job.errorStack}</pre> : null}

                    <h3><FormattedMessage defaultMessage="Tasks" id="jobView.tasks" /></h3>
                    <Grid columns={{
                        'name': {
                            // eslint-disable-next-line max-params
                            render: (column, item, url, columnMapping) => {
                                let value = Tool.getFormatted(types['jobTasks'], 'name', this.props.intl.formatMessage, item);

                                if (!value) {
                                    value = Tool.getFormatted(types['jobTasks'], 'typeName', this.props.intl.formatMessage, item);
                                }

                                if (!value) {
                                    value = Tool.getFormatted(types['jobTasks'], 'type', this.props.intl.formatMessage, item);
                                }

                                return value;
                            }
                        },
                        'status': {
                            // eslint-disable-next-line max-params
                            render: (column, item, url, columnMapping) => {
                                let result = renderProgress(type, item, this.props.intl.formatMessage);

                                if (item.message && BrowserPermission.hasPermission(Permission.PERM_DEVELOPER) && BrowserPermission.developerModeEnabled()) {
                                    return (<span>{result} <br/>{item.message}</span>);
                                }

                                return result;
                            }
                        },
                    }} list={job.jobTasks} metadata={type.relation('jobTasks').to} />
                </div>
            </div>
        );
    }
}

export default Relay.createContainer(injectIntl(JobDetail), {
    fragments: {
        job: () => Relay.QL`
            fragment on Job {
                id,
                organisation_id,
                type,
                name,
                channel {
                    id,
                    name,
                    organisation_id,
                    channelDef {
                        id,
                        name,
                        icon
                    }
                },
                message,
                errorStack,
                status,
                createdAt,
                updatedAt,
                progress,
                start,
                stop,
                productVersion,
                productStage,
                jobTasks {
                    id,
                    type,
                    typeName,
                    name,
                    order,
                    status,
                    stage,
                    progress,
                    errorStack,
                    message,
                }
            }
        `,
    },
});
